export default "__VITE_ASSET__6c8eaf66__"